import React from 'react';
import { Button, Typography, BaseIcon } from '@scale/scaleui';
import { Link } from 'react-router-dom';
import { Routes } from 'react-scale/components/GrowthCenter/urls';
import useUnleashFeatureFlag from 'react-scale/hooks/useUnleashFeatureFlag';
import { IUserJson } from '@scale/shared/types/user';

const Header: React.FC<{ user: IUserJson }> = ({ user }) => {
  const canAccessSms = useUnleashFeatureFlag('growth-sms', { userId: user!._id }, false);
  return (
    <div className="flex flex-row justify-between w-full gap-5 items-center">
      <div>
        <Typography.H4>SMS Communications</Typography.H4>
      </div>
      {canAccessSms && (
        <div className="min-w-[150px]">
          <Link to={Routes.SmsSetup}>
            <Button size="lg" variant="primary">
              <BaseIcon contrastText edge="start" icon={['fas', 'plus']} />
              New SMS Communication
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default Header;
